export enum PlatformType {
  buyside = 'buyside',
  polaris = 'polaris',
}

export interface MuniEnvironmentParams extends Record<string, unknown> {
  platform: PlatformType;
  env: MuniEnvironment;
  apiHost: string;
}

export enum MuniEnvironment {
  dev = 'dev',
  qx = 'qx',
  demo = 'demo',
  mo = 'mo',
  prod = 'prod',
}
